const normalizePlate = value => String(value || "").toUpperCase().replace(/[^A-Z0-9]/g, "");

export function isQueueReserved(row) {
	return Boolean(row.allocation?.checkpointId) && (row.allocation.status
		? row.allocation.status === "RESERVED" : row.queueStatus === "READY");
}

export function queueBayLabel(row, checkpointName) {
	if (!row.allocation?.checkpointId) return "Bay not assigned";
	const name = row.allocation.checkpointName || checkpointName || "Name unavailable";
	return isQueueReserved(row) ? `Reserved: ${name}` : `Waiting for ${name}`;
}

export function filterQueueRows(rows, selectedBay, vehicleSearch) {
	const search = normalizePlate(vehicleSearch);
	return rows.map((row, index) => ({ row, order: index + 1 })).filter(({ row }) => {
		const allocatedBay = row.allocation?.checkpointId;
		const matchesBay = selectedBay === "all" || (selectedBay === "unreserved"
			? !allocatedBay : String(allocatedBay) === selectedBay);
		return matchesBay && (!search || normalizePlate(row.vehicleNumber).includes(search));
	});
}
